import './tab-nav.scss';

class TabNav {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-tabnav',
            tabAttr: 'data-tabnav-tab',
            targetAttr: 'data-tabnav-target'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$tabNav = $element;
        this.$tabsWrapper = this.$tabNav.querySelector(`[${this.settings.initAttr}="tabs"]`);
        this.$$tabs = this.$tabNav.querySelectorAll(`[${this.settings.tabAttr}]`);
        this.$$targets = this.$tabNav.querySelectorAll(`[${this.settings.targetAttr}]`);
        this.$tabNavigator = null;
        this.$activeTab = null;

        this.resizeHandler = window.resizeHandler;
        this.inital = true;

        this.initialize();
    }

    initialize () {
        if (this.$$tabs.length > 0) {
            this.setActive();
        }

        this.setEvents();
    }

    generateNavigator () {
        if (this.$tabsWrapper) {
            this.$tabNavigator = document.createElement('div');
            this.$tabNavigator.classList.add('tabnav__navigator');
            this.$tabNavigator.ariaLabel = 'Tab navigator';
            this.$tabsWrapper.appendChild(this.$tabNavigator);
        }
    }

    setNavigator () {
        for (let index = 0; index < this.$$tabs.length; index++) {
            if (this.$$tabs[index].classList.contains('is--active')) {
                this.$activeTab = this.$$tabs[index];
            }
        }

        const width = this.$activeTab.offsetWidth;
        const left = `${this.$activeTab.offsetLeft}px`;

        this.$tabNavigator.style.setProperty('--left', `${left}`);
        this.$tabNavigator.style.setProperty('--width', `${width}px`);
    }

    setActive (element) {
        if (this.inital) {
            this.$activeTab = this.$$tabs[0];
            this.generateNavigator();
            this.inital = false;
        } else {
            this.$activeTab = element;
        }

        const targetValue = this.$activeTab.getAttribute(this.settings.tabAttr);
        const $target = this.$tabNav.querySelector(`[${this.settings.targetAttr}="${targetValue}"]`);

        if ($target) {
            for (let index = 0; index < this.$$targets.length; index++) {
                if (this.$$targets[index] !== $target) {
                    this.$$targets[index].classList.remove('is--active');
                } else {
                    $target.classList.add('is--active');
                }
            }

            for (let index = 0; index < this.$$tabs.length; index++) {
                if (this.$$tabs[index] !== this.$activeTab) {
                    this.$$tabs[index].classList.remove('is--active');
                } else {
                    this.$activeTab.classList.add('is--active');
                }
            }
        }

        this.setNavigator();
    }

    setEvents () {
        if (this.$$tabs.length > 0) {
            this.$$tabs.forEach(tab => {
                tab.addEventListener('click', (e) => {
                    this.setActive(e.target);
                });
            });
        }

        this.resizeHandler.customFunctions.push(() => {
            this.setNavigator();
        });
    }
}

export { TabNav };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$tabNav = $context.querySelectorAll('[data-tabnav="root"]');
        for (let i = 0; i < $$tabNav.length; i++) {
            const $tabNav = $$tabNav[i];

            const tabNavAPI = new TabNav($tabNav);
            $tabNav.API = tabNavAPI;
        }
    }
});
